import { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';
import UserInfoPage from './pages/UserInfoPage/UserInfoPage';
import ThankYouPage from './pages/ThankYouPage';
import ErrorPage from './pages/ErrorPage';
import SinisterSelectPage from './pages/SinisterSelectPage/SinisterSelectPage';
import OtherCasePage from './pages/OtherCasePage';
import InsuranceInfoPage from './pages/InsuranceInfoPage';
import BeforeStartPage from './pages/BeforeStartPage';
import FilesAttachPage from './pages/FilesAttachPage';
import AmountInfoPage from './pages/AmountInfoPage';
import RefundInfoPage from './pages/RefundInfoPage';
import ValidateInfoPage from './pages/ValidateInfoPage';

import OldSiniesrSelectPage from './old-pages/SinisterSelectPage';
import OldInsuranceInfoPage from './old-pages/InsuranceInfoPage';
import OldBeforeStartPage from './old-pages/BeforeStartPage';
import OldFilesAttachPage from './old-pages/FilesAttachPage';
import OldAmountInfoPage from './old-pages/AmountInfoPage';
import OldRefundInfoPage from './old-pages/RefundInfoPage';
import OldValidateInfoPage from './old-pages/ValidateInfoPage';
import OldThankYouPage from './old-pages/ThankYouPage';
import { PAGINAS_BY_STEP } from './utils/constants';

const App = () => {
  const formCurrentStep = useSelector(
    (state) => state.sinisterCards.currentStep
  );

  useEffect(() => {
    const tobi = document.querySelector('body .chatbotRimac__old');
    console.log('tobi*', tobi);
    if (tobi) {
      tobi.remove();
    }
    const helpButton = document.querySelector('.helpButton');
    console.log('helpButton*', helpButton);
    if (helpButton) {
      helpButton.remove();
    }
  }, [])

  return (
    <div data-testid="app" className="App">
      <Switch>
        <Route exact path="/" component={UserInfoPage} />
        {/* OLD FORM */}
        <ProtectedRoute
          exact
          path="/detalle-siniestro"
          component={OldSiniesrSelectPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path="/otros-seguros"
          component={OldInsuranceInfoPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path="/antes-de-comenzar"
          component={OldBeforeStartPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path="/documentos-requeridos"
          component={OldFilesAttachPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path="/montos-robados"
          component={OldAmountInfoPage}
          isGivenAccess={formCurrentStep >= 2}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path="/info-reembolso"
          component={OldRefundInfoPage}
          isGivenAccess={formCurrentStep >= 3}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path="/resumen"
          component={OldValidateInfoPage}
          isGivenAccess={formCurrentStep >= 4}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path="/gracias"
          component={OldThankYouPage}
          isGivenAccess={formCurrentStep === PAGINAS_BY_STEP.THANKYOU.step}
          redirectTo={'/'}
        />
        <Route path="/error" component={ErrorPage} />

        {/* NEW FORM */}
        <ProtectedRoute
          exact
          path={['/premium/detalle-siniestro', '/total/detalle-siniestro']}
          component={SinisterSelectPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={['/premium/otros-seguros', '/total/otros-seguros']}
          component={InsuranceInfoPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={['/premium/otro-caso', '/total/otro-caso']}
          component={OtherCasePage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={['/premium/antes-de-comenzar', '/total/antes-de-comenzar']}
          component={BeforeStartPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={[
            '/premium/documentos-requeridos',
            '/total/documentos-requeridos',
            '/attach/documentos-requeridos',
          ]}
          component={FilesAttachPage}
          isGivenAccess={formCurrentStep >= 1}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={['/premium/montos-robados', '/total/montos-robados']}
          component={AmountInfoPage}
          isGivenAccess={formCurrentStep >= 2}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={['/premium/info-reembolso', '/total/info-reembolso']}
          component={RefundInfoPage}
          isGivenAccess={formCurrentStep >= 3}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={['/premium/resumen', '/total/resumen']}
          component={ValidateInfoPage}
          isGivenAccess={formCurrentStep >= 4}
          redirectTo={'/'}
        />
        <ProtectedRoute
          exact
          path={['/new-gracias']}
          component={ThankYouPage}
          isGivenAccess={formCurrentStep === PAGINAS_BY_STEP.NEW_THANKYOU.step}
          redirectTo={'/'}
        />
        <Route path="/new-error" component={ErrorPage} />
        <Route render={(props) => <ErrorPage {...props} is404 />} />
      </Switch>
    </div>
  );
};

export default App;
